import loadJS from 'load-js'

import { isLocalEnv } from './env'

export const dependencies = [
    {
        // HubSpot
        text: (
            `(function(w,d,s,p,i){window.hsConversationsSettings=p;var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s);j.async=true;j.src='https://js.hs-scripts.com/'+i+'.js';
            f.parentNode.insertBefore(j,f);})(window,document,'script',{loadImmediately:false},5756448);`
        ),
        removeInLocalEnv: true
    },
    {
        // Dropbox
        url: 'https://www.dropbox.com/static/api/2/dropins.js',
        async: true
    },
    {
        // Google Tag Manager
        text: (
            `dataLayer=[];(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','GTM-5393TWM');`
        ),
        skipInMockRun: true
    },
    {
        // Calendly
        url: 'https://assets.calendly.com/assets/external/widget.js'
    }
]

export default function loadDependencies() {
    const isMockRun = (() => {
        // Dev-harness only: never let `?mock=1` alter dependency loading in a production build.
        if (process.env.NODE_ENV === 'production') return false
        try { return new URLSearchParams(window.location.search).get('mock') === '1' } catch { return false }
    })()
    const selected = (isLocalEnv
        ? dependencies.filter(d => !d.removeInLocalEnv)
        : dependencies
    ).filter(d => !(isMockRun && d.skipInMockRun))
    loadJS(selected).catch(err => console.warn('Fail on loading dependency', err))
}
